class Enums {
	constructor(name) {
		this.data = window.enums[name] || {};

		for (let i in this.data.display) {
			Object.defineProperty(
				this,
				i,
				{
					get: function () {
						return i;
					}
				}
			);
		}
	}

	getKeys() {
		return Object.keys(this.data.display);
	}

	getKey(key) {
		if (!this.data.display.hasOwnProperty(key)) {
			console.log("Invalid enum value: " + key);
			return;
		}

		return key;
	}

	display(key = null, plural = false) {
		let data = !plural ? this.data.display : this.data.displayPlural;

		if (!key) {
			return data;
		}

		return data[key];

		// if (!plural) {
		// 	return !key ? this.data.display : this.data.display[key]
		// }
		//
		// return !key ? this.data.displayPlural : this.data.displayPlural[key]
	}

	has(key = null, plural = false) {
		let data = !plural ? this.data.display : this.data.displayPlural;

		if ("undefined" === typeof data) {
			return false;
		}

		return data.hasOwnProperty(key);
	}
}

export default {
	methods: {
		$enum(name) {
			return new Enums(name);
		},
	},
};
